import { Link, useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-16 bg-slate-50" data-testid="payment-cancel-page">
      <div className="max-w-lg w-full text-center bg-white rounded-3xl border border-slate-200 p-10 shadow-sm">
        <div className="inline-flex h-16 w-16 rounded-full bg-slate-100 items-center justify-center mb-5">
          <XCircle className="h-8 w-8 text-slate-500" />
        </div>
        <h1 className="text-2xl font-bold text-[#0F2744]">Payment cancelled</h1>
        <p className="mt-3 text-slate-600">No problem — you haven't been charged. Your details are saved, so you can pick up your application and pay whenever you're ready.</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={() => navigate("/join")} className="bg-amber-500 hover:bg-amber-600 text-[#0F2744] font-bold" data-testid="payment-cancel-retry">Return to application</Button>
          <Button asChild variant="outline"><Link to="/">Back to home</Link></Button>
        </div>
      </div>
    </div>
  );
}
